var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link flex align-center justify-center cs",style:({marginTop: _vm.isSwiper?'':'14px'})},[(_vm.isHave)?_c('span',{style:({'border':_vm.isHaveLine?'':'none'})},[_vm._v(_vm._s(_vm.text)+" >>")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }